export default __webpack_public_path__ + "static/media/liam.82ddee81.jpeg";